import { LinkWithArrow } from "components";
import { OrderPaymentMethod, OrderPaymentMethods } from "modules/orders";
import { useTranslation } from "react-i18next";

import {
  MainDetailsItemProps,
  TransactionMainDetailsProps
} from "../../TransactionDetailsModal.types";

import styles from "./TransactionMainDetails.module.scss";

const TransactionMainDetails = ({
  transaction
}: TransactionMainDetailsProps) => {
  const { t } = useTranslation();

  const DetailsItem = ({ title, info, icon, color }: MainDetailsItemProps) => {
    return (
      <div className={styles["transaction__details--item"]}>
        <p className={styles["transaction__details--item-title"]}>{t(title)}</p>

        <p
          className={styles["transaction__details--item-info"]}
          style={{ color }}
        >
          {icon ?? null}
          {info}
        </p>
      </div>
    );
  };

  return (
    <>
      <DetailsItem title="Transaction Number" info={transaction.id} />
      <DetailsItem
        title="Related Order"
        info={
          <div className={styles["transaction__details--orderCell"]}>
            <p>{transaction.orderId}</p>
            <LinkWithArrow
              to={{
                pathname: "/orders",
                search: `orderId=${transaction.orderId}`
              }}
              text="Show order"
            />
          </div>
        }
        color="#FB3973"
      />
      <DetailsItem
        title="Total Amount"
        info={transaction.amount.toLocaleString("en-US")}
      />
      <DetailsItem
        title="Payment Method"
        info={t(
          OrderPaymentMethods[transaction.paymentMethod as OrderPaymentMethod]
            .label
        )}
        icon={OrderPaymentMethods.CashOnDelivery.icon}
      />
    </>
  );
};

export default TransactionMainDetails;
